module.exports = __webpack_public_path__ + "h5/img/vip6.5874c897.png";